import * as yup from "yup";
import {stringRequired} from "../../../../../yup/defaultValudations";

export const initialValues = {organization: "", since: ""};

export const schema = yup.object().shape({
  members: yup.array().of(
    yup.object().shape({
      organization: stringRequired(),
      since: stringRequired(),
    })
  ),
});
